import React from 'react';

const AuthzSubjectPermissionFormModal = React.lazy(() => import('../components/FormModal'));
const authzSubjectPermissionModalRegistry = {
    core_authzSubjectPermissionId: AuthzSubjectPermissionFormModal
};
export default authzSubjectPermissionModalRegistry;
